import { render, staticRenderFns } from "./KreirajGrupuLink.vue?vue&type=template&id=984fa56c&scoped=true&"
import script from "./KreirajGrupuLink.vue?vue&type=script&lang=js&"
export * from "./KreirajGrupuLink.vue?vue&type=script&lang=js&"
import style0 from "./KreirajGrupuLink.vue?vue&type=style&index=0&id=984fa56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984fa56c",
  null
  
)

export default component.exports